import styled from 'styled-components';
import { Input, LoadingShape } from 'react-rainbow-components';
import { color } from 'theme';
import { DIVIDER } from '../../constants';

export const FieldContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-self: stretch;
    margin-bottom: 0.5rem;
    margin-top: 1rem;
`;

export const InputContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['$error'].includes(prop),
})<{ $error: boolean }>`
    border-radius: 0.75rem;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    width: 100%;
    font-size: 0.75rem;
    background: ${color('background.main')};
    transition: opacity 0.1s linear, visibility 0.1s linear;
    margin: 0;
    border: 1px solid ${DIVIDER};

    ${(props) => props.$error && `
        background-clip: padding-box;
        border: 2px solid ${color('error.main')};
    `};
`;

export const ErrorText = styled.div`
    font-size: 0.875rem;
    margin-top: 0.5rem;
    align-self: start;
    color: ${color('error.main')};
`;

export const StyledItemContainer = styled.div`
    display: flex;
    justify-content: stretch;
    align-items: center;
    padding: 0.75rem 0.75rem;
    color: ${color('text.main')};
    flex: 1; 
`;

export const StyledInput = styled(Input)`
    display: inline;
    margin-bottom: 0;
    margin-left: 4px;
    div[id^="error-message-"] {
        display: none;
    }
`;

export const LabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 5px;

    &  > span:first-child {
        font-family: Lato;
        font-size: 14px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        text-align: left;
        color: ${color('text.main')}
    }

    &  > span:last-child {
        font-family: Lato;
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0em;
        text-align: left;
        color: ${color('text.header')}
    }
`;

export const StyledLoadingShape = styled(LoadingShape).withConfig({
    shouldForwardProp: (prop) => !['$width'].includes(prop),
})<{ $width?: string }>`
    margin: 8px 16px;
    display: flex;
    width: ${(props) => props.$width};

    &:first-child {
        margin-top: 14px;
    }

    &:last-child {
        margin-bottom: 14px;
    }
`;

export const EmptyMessage = styled.div`
    font-family: 'Lato';
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0em;
    text-align: left;
    display: flex;
    flex: 1;
    height: 60px;
    align-items: center;
    justify-content: center;
    color: ${color('text.title')};
`;
